var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('span',{staticClass:"muted"},[_vm._v(_vm._s(_vm.prefix))]),_c('span',{staticClass:"strong"},[_vm._v(_vm._s(_vm.price))]),_c('span',{staticClass:"muted"},[_vm._v(_vm._s(_vm.suffix))])])
}
var staticRenderFns = []

export { render, staticRenderFns }